export default {
  default: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-neutral_3/80 text-white",
  
  success: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-success text-white",
  
  error: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-error text-white",
  
  warning: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-warning text-white",
  
  info: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary_lt text-white",
  
  // Admin variants using admin color system
  admin_default: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-admin_neutral_3/80 text-white",
  
  admin_success: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-admin_success text-white",
  
  admin_error: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-admin_error text-white",
  
  admin_warning: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-admin_warning text-white",
  
  admin_info: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-admin_info_bg text-admin_text",
  
  admin_primary: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-admin_primary_dk text-white",

  // Size variants
  small: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium",
  
  large: "inline-flex items-center px-3 py-1 rounded-full text-sm font-medium",
  
  // Compact variant
  compact: "inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium",
}